import Vue from 'vue'
import OpeningUtil from '../util/OpeningUtil'
import VueRouter from 'vue-router'
import Forbidden from '../components/pages/Forbidden.vue'
import NotFound from '../components/pages/NotFound.vue'
import InternalServerError from '../components/pages/InternalServerError.vue'
import Maintenance from '../components/pages/Maintenance.vue'
import BadGateway from '../components/pages/BadGateway.vue'
import Home from '../components/pages/Home.vue'
import Talkshows from '../components/pages/Talkshows.vue'
import TalkshowsArchives from '../components/pages/TalkshowsArchives.vue'
import TalkshowsExhibitors from '../components/pages/TalkshowsExhibitors.vue'
import Exhibitors from '../components/pages/Exhibitors.vue'
import About from '../components/pages/About.vue'
import Artworks from '../components/pages/Artworks.vue'
import ArtworkCategory from '../components/pages/ArtworkCategory.vue'
import ArtworkCategoryJ100 from '../components/pages/ArtworkCategoryJ100.vue'
import ArtworkCategoryOrganizer from '../components/pages/ArtworkCategoryOrganizer.vue'
import ArtworkCategoryCastleAndMoon from '../components/pages/ArtworkCategoryCastleAndMoon.vue'
import ArtworkCategoryTwitter from '../components/pages/ArtworkCategoryTwitter.vue'
import ArtworkCategoryInstagram from '../components/pages/ArtworkCategoryInstagram.vue'
import ArtworkCategoryJtg from '../components/pages/ArtworkCategoryJtg.vue'
import ArtworkCategoryWeibo from '../components/pages/ArtworkCategoryWeibo.vue'
import ArtworkCategoryTccTest from '../components/pages/ArtworkCategoryTccTest.vue'
import ArtworksWinner from '../components/pages/ArtworksWinner.vue'
import Specials from '../components/pages/Specials.vue'
import UpdateInfo from '../components/pages/UpdateInfo.vue'
import Reports from '../components/pages/reports/Reports.vue'
import Natgeo from '../components/pages/reports/Natgeo.vue'
import Biei from '../components/pages/reports/Biei.vue'
import Thirdwave from '../components/pages/reports/Thirdwave.vue'
import LeicaLumix from '../components/pages/reports/LeicaLumix.vue'
import NikonU22 from '../components/pages/reports/NikonU22.vue'
import Canon from '../components/pages/reports/Canon.vue'
import Higashikawa from '../components/pages/reports/Higashikawa.vue'
import Tcc from '../components/pages/reports/Tcc.vue'
import TokenReceive from '../components/pages/TokenReceive.vue'
import OpenCtrl from '../components/pages/OpenCtrl.vue'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: '東京カメラ部2022写真展 Online Exhibition「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc :'' }
  },
  {
    path: '/forbidden',
    name: 'forbidden',
    component: Forbidden
  },
  {
    path: '/not-found',
    name: 'notFound',
    component: NotFound
  },
  {
    path: '/internal-server-error',
    name: 'internalServerError',
    component: InternalServerError
  },
  {
    path: '/bad-gateway',
    name: 'badGateway',
    component: BadGateway
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: Maintenance
  },
  // 個別ページ以下 10選
  {
    path: '/t10s/:year/:id/images/:winningWorkId',
    name: 't10sImage',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/t10s/:year/:id/portfolios/:portfolioId/:index',
    name: 't10sPortfolioIndex',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/t10s/:year/:id/portfolios/:portfolioId',
    name: 't10sPortfolio',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/t10s/:year/:id',
    name: 't10s',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  // 個別ページ以下 100景
  {
    path: '/j100v/:area/:pref/:id/images/:winningWorkId',
    name: 'j100vImage',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/j100v/:area/:pref/:id/portfolios/:portfolioId/:index',
    name: 'j100vPortfoliosIndex',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/j100v/:area/:pref/:id/portfolios/:portfolioId',
    name: 'j100vPortfolios',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/j100v/:area/:pref/:id',
    name: 'j100v',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  // 個別ページ以下 主催者企画 「城と月」特別部門
  {
    path: '/organizer/castleandmoon/:id/images/:winningWorkId',
    name: 'castleandmoonImage',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/castleandmoon/:id/portfolios/:portfolioId/:index',
    name: 'castleandmoonPortfolioIndex',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/castleandmoon/:id/portfolios/:portfolioId',
    name: 'castleandmoonPortfolio',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/castleandmoon/:id',
    name: 'castleandmoon',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  // 個別ページ以下 主催者企画Twitter
  {
    path: '/organizer/twitter/:id/images/:winningWorkId',
    name: 'twitterImage',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/twitter/:id/portfolios/:portfolioId/:index',
    name: 'twitterPortfolioIndex',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/twitter/:id/portfolios/:portfolioId',
    name: 'twitterPortfolio',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/twitter/:id',
    name: 'twitter',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  // 個別ページ以下 主催者企画Instagram
  {
    path: '/organizer/instagram/:id/images/:winningWorkId',
    name: 'instagramImage',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/instagram/:id/portfolios/:portfolioId/:index',
    name: 'instagramPortfolioIndex',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/instagram/:id/portfolios/:portfolioId',
    name: 'instagramPortfolio',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/instagram/:id',
    name: 'instagram',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  // 個別ページ以下 主催者企画jtg
  {
    path: '/organizer/jtg/:id/images/:winningWorkId',
    name: 'jtgImage',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/jtg/:id/portfolios/:portfolioId/:index',
    name: 'jtgPortfoliosIndex',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/jtg/:id/portfolios/:portfolioId',
    name: 'jtgPortfolios',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/jtg/:id',
    name: 'jtg',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  // 個別ページ以下 主催者企画weibo
  {
    path: '/organizer/weibo/:id/images/:winningWorkId',
    name: 'weiboImage',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/weibo/:id/portfolios/:portfolioId/:index',
    name: 'weiboPortfoliosIndex',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/weibo/:id/portfolios/:portfolioId',
    name: 'weiboPortfolios',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/weibo/:id',
    name: 'weibo',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  // 個別ページ以下 協賛展示
  {
    path: '/sponsors/:id/images/:winningWorkId',
    name: 'sponsorsImage',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/sponsors/:id/portfolios/:portfolioId/:index',
    name: 'sponsorsPortfoliosIndex',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/sponsors/:id/portfolios/:portfolioId',
    name: 'sponsorsPortfolios',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/sponsors/:id',
    name: 'sponsors',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  // 個別ページTCCテスト
  {
    path: '/tcc/umue37w3cepffokfglc6/:id/images/:winningWorkId',
    name: 'tccPageImage',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/tcc/umue37w3cepffokfglc6/:id/portfolios/:portfolioId/:index',
    name: 'tccPagePortfolioIndex',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/tcc/umue37w3cepffokfglc6/:id/portfolios/:portfolioId',
    name: 'tccPagePortfolio',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/tcc/umue37w3cepffokfglc6/:id',
    name: 'tccPage',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },

  // カテゴリページ 10選
  {
    path: '/t10s/:year',
    name: 't10sCategoryYear',
    component: ArtworkCategory,
    meta: { title: '東京カメラ部10選 | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/t10s',
    name: 't10sCategory',
    component: ArtworkCategory,
    meta: { title: '東京カメラ部10選 | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  // カテゴリページ 100景
  {
    path: '/j100v/:area/:pref',
    name: 'j100vCategoryPref',
    component: ArtworkCategoryJ100,
    meta: { title: '日本写真100景 | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/j100v/:area',
    name: 'j100vCategoryArea',
    component: ArtworkCategoryJ100,
    meta: { title: '日本写真100景 | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/j100v',
    name: 'j100vCategory',
    component: ArtworkCategoryJ100,
    meta: { title: '日本写真100景 | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  // カテゴリページ 主催者企画
  {
    path: '/organizer/castleandmoon',
    name: 'castleAndMoonCategory',
    component: ArtworkCategoryCastleAndMoon,
    meta: { title: '主催者企画 | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/twitter',
    name: 'twitterCategory',
    component: ArtworkCategoryTwitter,
    meta: { title: '主催者企画 | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/instagram',
    name: 'instagramCategory',
    component: ArtworkCategoryInstagram,
    meta: { title: '主催者企画 | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/jtg',
    name: 'jtgCategory',
    component: ArtworkCategoryJtg,
    meta: { title: '主催者企画 | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer/weibo',
    name: 'weiboCategory',
    component: ArtworkCategoryWeibo,
    meta: { title: '主催者企画 | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/organizer',
    name: 'organizer',
    component: ArtworkCategoryOrganizer,
    meta: { title: '主催者企画 | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  // カテゴリページTCCテスト
  {
    path: '/tcc/umue37w3cepffokfglc6',
    name: 'tccTest',
    component: ArtworkCategoryTccTest,
    meta: { title: '主催者企画 | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  // カテゴリー 協賛展示
  {
    path: '/sponsors',
    name: 'sponsorsCategory',
    component: Specials,
    meta: { title: '協賛展示 | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/exhibitors',
    name: 'exhibitors',
    component: Exhibitors,
    meta: { title: '展示者一覧 | 作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: { title: '開催概要 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/artworks',
    name: 'artworks',
    component: Artworks,
    meta: { title: '作品展示 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/events',
    name: 'events',
    component: Talkshows,
    meta: { title: '主催者公式イベント | イベントカレンダー |  東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/events/exhibitors',
    name: 'eventsExhibitors',
    component: TalkshowsExhibitors,
    meta: { title: '出展者自主企画イベント | イベントカレンダー |  東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/events/archives',
    name: 'eventsArchives',
    component: TalkshowsArchives,
    meta: { title: '主催者イベントアーカイブ | イベントカレンダー |  東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/updateinfo',
    name: 'updateinfo',
    component: UpdateInfo,
    meta: { title: 'アップデート情報 | 東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  // リポートページ
  {
    path: '/reports/natgeo',
    name: 'natgeo',
    component: Natgeo,
    meta: { title: '日経ナショナル ジオグラフィック 公式写真集＆ムック本発売記念「美しい世界との出会い」', desc: '' }
  },
  {
    path: '/reports/biei',
    name: 'biei',
    component: Biei,
    meta: { title: '美瑛町（ＮＰＯ法人　美瑛町写真映像協会） 丘のまち風景写真の源流～美瑛町と前田真三', desc: '' }
  },
  {
    path: '/reports/thirdwave',
    name: 'thirdwave',
    component: Thirdwave,
    meta: { title: 'サードウェーブ "オリジナリティ"とはレタッチで決まる！ raytrekで叶える写真のレベルアップ', desc: '' }
  },
  {
    path: '/reports/leicalumix',
    name: 'leicalumix',
    component: LeicaLumix,
    meta: { title: 'LEICA x LUMIX コムロミホトークイベント', desc: '' }
  },
  {
    path: '/reports/nikon_u22',
    name: 'nikon_u22',
    component: NikonU22,
    meta: { title: '東京カメラ部10選U-22と次の未来を語る ～新世代のNikon Creators～', desc: '' }
  },
  {
    path: '/reports/canon',
    name: 'canon',
    component: Canon,
    meta: { title: 'キヤノンマーケティングジャパン 僕らの写真時代', desc: '' }
  },
  {
    path: '/reports/higashikawa',
    name: 'higashikawa',
    component: Higashikawa,
    meta: { title: '東川町・ひがしかわ観光協会 なぜ人々は「北海道東川町」に惹き付けられるのか', desc: '' }
  },
  {
    path: '/reports/tcc',
    name: 'tcc',
    component: Tcc,
    meta: { title: '東京カメラ部 【東京カメラ部2022写真展】カウントダウントークショー「写真との出会いは、世界との出会いだ。」', desc: '' }
  },
  {
    path: '/reports',
    name: 'reports',
    component: Reports,
    meta: { title: 'ヒカリエトークステージレポート', desc: '' }
  },
  /*
  {
    path: '/events/report_canon',
    name: 'reportCanon',
    component: ReportCanon,
    meta: { title: 'キヤノンマーケティングジャパン株式会社「EOS R、 EOS R5 、そして今 EOS R3 へ」|トークショーレポート｜東京カメラ部2022写真展 Online Exhibition「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/events/report_raytrek',
    name: 'reportRaytrek',
    component: ReportRaytrek,
    meta: { title: '株式会社サードウェーブ「クリエイターPC視点 raytrekのレタッチお悩み解決Before & Afterご紹介」|トークショーレポート｜東京カメラ部2022写真展 Online Exhibition「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/events/report_biei',
    name: 'reportBiei',
    component: ReportBiei,
    meta: { title: '美瑛町（ＮＰＯ法人 美瑛町写真映像協会）「カメラと旅する北海道・美瑛町」|トークショーレポート｜東京カメラ部2022写真展 Online Exhibition「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  */
  {
    path: '/token_receive',
    name: 'tokenReceive',
    component: TokenReceive,
    meta: { title: '東京カメラ部2022写真展 Online Exhibition 「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -」', desc: '' }
  },
  {
    path: '/system/77dp7c581534pmhbcl7rpns44mf53dts/:type',
    name: 'openCtrl',
    component: OpenCtrl,
    meta: { title: 'system', desc: '' }
  },
  {
    path: '*',
    redirect: '/not-found'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) return savedPosition // 戻るボタン対応
    // 画像詳細とポートフォリオから復帰した場合は、元のスクロール位置を保持する
    if (
      (to && to.path && to.path.indexOf('/images/') >= 0) ||
      (from && from.path && from.path.indexOf('/images/')) >= 0 ||
      (to && to.path && to.path.indexOf('/portfolios/') >= 0) ||
      (from && from.path && from.path.indexOf('/portfolios/')) >= 0
    ) {
      return null
    } else {
      // スクロール位置を左上にリセット
      return { x: 0, y: 0 }
    }
  }
})

// bodyにパスの第1階層を名前としたclassを設定する処理
router.beforeEach(async (to, from, next) => {
  if (to.path === '/') {
    document.body.className = 'topPage'
  } else {
    const pathArray = to.path.split('/')
    if (pathArray.length > 1 && pathArray[1]) {
      document.body.className = pathArray[1]
    } else {
      document.body.className = ''
    }
  }

  // 写真展開催判定
  // 開催前の場合は、常にHomeに飛ばしてしまう。
  // なお、Homeでも、同じく、開催前判定を行い、開催前の場合は、coming soonを表示する。
  if (
       to.path != '/' // ホーム以外の場合
    && to.path.indexOf('/system/77dp7c581534pmhbcl7rpns44mf53dts') < 0 // かつ、開催・終了状態設定処理以外の場合
    && !await OpeningUtil.isOpend() // かつ、開催期間前だった場合
  ) {
    next({ path: '/' }) // ホーム画面に飛ばす
  } else if(OpeningUtil.isClosed() // 終了していて、
    && (to.path == '/events' || to.path == '/events/' || to.path == '/events/exhibitors' || to.path == '/events/exhibitors/') // イベント表示だったら
  ) {
    next({ path: '/events/archives' }) // イベントアーカイブ画面に飛ばす
  } else {
    next()
  }
})

export default router
